<template>
<v-app>
  <v-main>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
    <v-toolbar elevation="1">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-layout row class="display-1 ml-2">
        <div id="font">
          Simples
        </div>

        <div id="font" class="primary--text">
          Medic
        </div>
      </v-layout>
    </v-toolbar>
    <!-- <v-toolbar class="teal lighten-2">
        <v-toolbar-side-icon
          style="color:white"
          @click.stop="drawer = !drawer"
        />
        <v-toolbar-title style="color:white">
          <h4>Administrador Desenvolvedor</h4>
        </v-toolbar-title>
        <v-spacer />
      </v-toolbar> -->
    <v-layout wrap style="height: 680px;">
      <router-view />
      <!-- oi -->

      <v-navigation-drawer v-model="drawer" absolute temporary>
        <v-list class="pa-1  teal lighten-2">
          <v-list-item avatar>
            <v-list-item-avatar>
              <v-img :src="require('../assets/adminDev/aami2-31-512.png')" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="white--text font-weight-bold">
                {{ this.$store.getters.usuario.nome }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-list class="pt-0">
          <v-divider />

          <v-list-item v-for="item in items" :key="item.title" :to="{path:item.rota}">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-group prepend-icon="settings">
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-title>Configurações</v-list-item-title>
              </v-list-item>
            </template>

            <v-list-item v-for="(admin, i) in admins" :key="i" :to="{path:admin[2]}">
              <v-list-item-title v-text="admin[0]" />
              <v-list-item-action>
                <v-icon v-text="admin[1]" />
              </v-list-item-action>
            </v-list-item>
          </v-list-group>

          <v-list-item @click="logout()">
            <v-list-item-action>
              <v-icon>logout</v-icon>
            </v-list-item-action>

            <v-list-item-title>Logout</v-list-item-title>

            <v-list-item-content>
              <v-list-item-title />
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
    </v-layout>
  </v-main>
</v-app>
</template>

<script>
// eslint-disable-next-line
/* eslint-disable */

import {
  EventBus
} from "../main";

export default {
  name: "homeAdministrador",
  data() {
    return {
      drawer: null,
      admins: [
        ["Alterar nome", "person", "/homeAdministradorDev"],
        ["Alterar senha", "vpn_key", "/homeAdministradorDev"]
      ],

      items: [{
          title: "Dashboard",
          icon: "dashboard",
          rota: "/homeAdministradorDev"
        },
        {
          title: "Vídeos",
          icon: "cast",
          rota: "/listaVideos"
        },
        {
          title: "Chat",
          icon: "chat",
          rota: "/chat"
        },
        {
          title: "Help",
          icon: "info",
          rota: "/help"
        }
      ],
      right: null
    };
  },
  props: {
    source: String
  },
  methods: {
    logout() {
      console.log("em logout..");
      //this.$router.push("/login");
      this.$store
        .dispatch("FedLogOut")
        .then(rsp => {
          console.log("11111111");
          this.$router.push("/login");
          if (r) {}
        })
        .catch(error => {
          //  this.progress = false;
          //  this.alert = true;
          //  this.msg = error;
        });
    }
  },

  mounted() {
    this.user = this.$store.getters.usuario;
    console.log("mounted adminDev", this.user);
    if (this.user.tipo != 10) {
      this.$router.push("/login");
      return;
    }
  }
};
</script>
